import request from '@/plugin/axios'
/**
 * 分页查询
 */
export function fetchList (query) {
  return request({
    url: '/tms/track/page',
    method: 'post',
    data: query
  })
}
/**
 *
 新增运单跟踪记录
 */
export function addObj (obj) {
  return request({
    url: '/tms/track',
    method: 'post',
    data: obj
  })
}
/**
 * 通过id查询
 */
export function getObj (id) {
  return request({
    url: '/tms/track/' + id,
    method: 'get'
  })
}
/**
 *
 通过id删除运单跟踪记录
 */
export function delObj (id) {
  return request({
    url: '/tms/track/' + id,
    method: 'delete'
  })
}
/**
 *
 修改运单跟踪记录
 */
export function putObj (obj) {
  return request({
    url: '/tms/track',
    method: 'put',
    data: obj
  })
}
/**
 *
 通过运单Id获取跟踪记录
 */
export function getObjList (id) {
  return request({
    url: '/tms/track/list/' + id,
    method: 'get'
  })
}
/**
 * 运单跟踪查询
 */
export function searchList (query) {
  return request({
    url: '/tms/track/search',
    method: 'post',
    data: query
  })
}
/**
 *
 通过Id获取信息
 */
export function getTmsydSign (id) {
  return request({
    url: '/tms/sign/' + id,
    method: 'get'
  })
}
/**
 *
 单票签收
 */
export function addTmsydSign (obj) {
  return request({
    url: '/tms/sign',
    method: 'post',
    data: obj
  })
}
/**
 *
 批量签收
 */
export function batchTmsydSign (obj) {
  return request({
    url: '/tms/sign/batch',
    method: 'post',
    params: obj
  })
}
/**
 *
 批量签收
 */
export function batchTmsydUndoSign (obj) {
  return request({
    url: '/tms/sign/undoBatch',
    method: 'post',
    params: obj
  })
}
/**
 *
 批量新增运单跟踪信息
 */
export function batchAddTrack (obj) {
  return request({
    url: '/tms/track/batchGenerateTrack',
    method: 'post',
    data: obj
  })
}
/**
 *
 根据运单号查询温控数据
 */
export function getTemperature (query) {
  return request({
    url: '/platform/temperature/queryByYd',
    method: 'get',
    params: query
  })
}
/**
 *
 修改温控数据
 */
export function updateTemperature (obj) {
  return request({
    url: '/platform/temperature/update',
    method: 'post',
    data: obj
  })
}
/**
 *
 删除温控数据
 */
export function deleteTemperature (id) {
  return request({
    url: '/platform/temperature/deleteById/' + id,
    method: 'post'
  })
}
/**
 *
 批量删除温控数据
 */
export function deleteTemperatureBatch (ydNo) {
  return request({
    url: '/platform/temperature/deleteByIdBatch',
    method: 'post',
    params: { ydNo: ydNo }
  })
}
/**
 *
 导入温控数据进度查询
 */
export function getTemperatureImportProgress () {
  return request({
    url: '/platform/temperature/progress',
    method: 'get'
  })
}
/**
 *
 新增运单跟踪记录
 */
export function addLocation (ydId, carNo) {
  return request({
    url: '/tms/track/vehicleLocation',
    method: 'get',
    params: { ydId: ydId, carNo: carNo }
  })
}
/**
 *
 下载温控pdf
 */
export function exportTemperatureChart (ydNo) {
  return request({
    url: '/platform/temperature/exportTemperatureChart',
    method: 'post',
    responseType: 'blob',
    params: { ydNo: ydNo }
  })
}

/**
 * 获取考核标准
 * @param ydId
 * @returns {*}
 */
export function getAssessmentInfoByYdId (ydIds) {
  return request({
    url: '/tms/assessment/getByYdId',
    method: 'get',
    params: { ydIds: ydIds }
  })
}
/**
 * 考核标准保存
 * @param obj
 * @returns {*}
 */
export function saveAssessment (obj) {
  return request({
    url: '/tms/assessment/save',
    method: 'post',
    data: obj
  })
}
